import { Flex } from '@buffer-mono/popcorn'

import {
  BookmarkIcon,
  ChartIcon,
  CommentIcon,
  LikeIcon,
  RepostIcon,
  ShareIcon,
} from '../../../../assets/twitter'

import styles from './Tweet.module.css'

import type { JSX } from 'react'

export const TweetActions = (): JSX.Element => {
  return (
    <Flex align="center" gap="lg" justify="between" className={styles.actions}>
      <CommentIcon size="small" color="currentColor" />
      <RepostIcon size="small" color="currentColor" />
      <LikeIcon size="small" color="currentColor" />
      <ChartIcon size="small" color="currentColor" />
      <Flex align="center" gap="sm">
        <BookmarkIcon size="small" color="currentColor" />
        <ShareIcon size="small" color="currentColor" />
      </Flex>
    </Flex>
  )
}
